module.exports = __webpack_public_path__ + "img/benefit6.a4f58b51.png";